"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extractTokens = extractTokens;
var TOKEN_REGEX = /:[\w_]+\/?/gi;

function extractTokens(path) {
  var matches = path.match(TOKEN_REGEX);

  if (!matches) {
    return [];
  }

  return matches.map(function (match) {
    // example:
    // match: :blogId/
    //        :postId
    //        :Post_id
    return match.replace(/\//g, '');
  });
}